module.exports = __webpack_public_path__ + "static/media/puzzle-dark.04faec9b.png";